export const AIR_SEAT_TYPES = {
  EXIT_ROW: "EXIT_ROW",
  EXTRA_LEGROOM: "EXTRA_LEGROOM",
  PREFERRED: "PREFERRED",
  STANDARD: "STANDARD",
};
